import { ActionTree } from 'vuex';
import { PipelineState } from './state';
import RootState from '@/store/root_state';
import pipeline from '@/pipeline';
// eslint-disable-next-line import/no-cycle
import router from '@/router';
import { MicroserviceEnum, mutation, query } from '@/helpers/westeros';
import { getPipelineRun, GetPipelineRunQueryResult } from '@/store/graphql/queries/westerosQueries';
import {
  upsertPipelineRun,
  UpsertPipelineRunMutationResult,
} from '@/store/graphql/mutations/westerosMutations';
import { Context } from '@/pipeline/stateMachine';
import { State } from 'xstate';
import Vue from 'vue';
import { AnalyticsActions } from '../analytics/actions';

const actions: ActionTree<PipelineState, RootState> = {
  async START_PIPELINE({ commit, state, rootState, dispatch }): Promise<void> {
    pipeline.start(router, state.currentState);

    pipeline.addTransitionListener(async (currentState: State<Context>) => {
      dispatch(AnalyticsActions.SCREEN_VIEWED);

      try {
        const variables = { admissionId: rootState.admission.admissionId, state: currentState };
        const { data } = await mutation<UpsertPipelineRunMutationResult>(
          MicroserviceEnum.ADMISSIONS,
          upsertPipelineRun,
          variables,
        ).catch(() => ({ data: null }));

        if (data?.upsertPipelineRun) {
          const pipeline: PipelineState = {
            id: data?.upsertPipelineRun.id,
            currentState: data?.upsertPipelineRun.state,
          };

          commit('SET_PIPELINE', pipeline);
        }
      } catch {
        // suppress error
      }
    }, true);
  },

  async PULL_PIPELINE({ commit, rootState }): Promise<void> {
    const isAuthenticated = Boolean(Vue.$cookies.get('admissions-auth-token'));

    if (!isAuthenticated) return;

    const variables = { admissionId: rootState.admission.admissionId };

    const { data } = await query<GetPipelineRunQueryResult>(
      MicroserviceEnum.ADMISSIONS,
      getPipelineRun,
      variables,
    ).catch(() => ({ data: null }));

    if (data?.getPipelineRun) {
      const pipeline: PipelineState = {
        id: data?.getPipelineRun.id,
        currentState: data?.getPipelineRun.state,
      };

      commit('SET_PIPELINE', pipeline);
    }
  },
};

export default actions;
